import axios from "axios";

const API_KEY = "0300337cd5mshf8057d09a0eeaf1p192843jsn01ce35f27c4a";

const baseUrl =
  "https://translated-mymemory---translation-memory.p.rapidapi.com/api/get";

const textHeader = {
  "x-rapidapi-host": "translated-mymemory---translation-memory.p.rapidapi.com",
  "x-rapidapi-key": API_KEY,
};

export const getTransData = async (finalText, orgLang, transLang) => {
  try {
    const { data } = await axios.get(baseUrl, {
      params: {
        langpair: `${orgLang}|${transLang}`,
        q: finalText,
      },
      headers: textHeader,
    });
    // console.log(data)
    return data;
  } catch (error) {
    console.log(error);
  }
};
